import React from 'react'
import { Link } from 'react-router-dom'

import { useGlobalContext } from '../context'
function BestSeller() {
    const { addToBag, products } = useGlobalContext()
    if (products.length > 0) {
        const { id, name, sizes, price, image, inStock } = products[1];
        return (
            <section className='best_seller'>
                <div className="container">
                    <h1 className='section-title'>Trending</h1>

                    <div className="product-info">
                        <Link to={`/product/${id}`} className="product-name">
                            {name}
                        </Link>
                        <p className="product-desc">Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
                        <ul className="feats">
                            <li className='feat'>ipsum.</li>
                            <li className='feat'>Lorem, ipsum dolor.</li>
                            <li className='feat'>Lorem ipsum dolor sit.</li>
                        </ul>
                        <ul className="sizes">
                            Sizes:
                            {sizes.map((size, index) => {
                                return (
                                    <li className="size" key={index}>{size}</li>
                                )
                            })}
                        </ul>
                        <button className="add-to-bag" onClick={() => addToBag(id)}>add to bag</button>
                    </div>
                    <div className="product-image">
                        <img src={image[0]} alt="" />
                        <div className="product-price">{price} <span>LE</span></div>
                    </div>
                </div>
            </section>
        )
    } else {
        return ' '
    }
}

export default BestSeller